<template>
  <div id="app">
      <HomeViewVue/>
  </div>
</template>

<script>
import HomeViewVue from './views/HomeView.vue';

export default { 
   components: {
    HomeViewVue
   },
    props: {},
   
}
</script>
<style lang="scss">
body {
  width: 100%;
  min-width: 1000px;
  overflow: auto;
}

</style>
